import {
  IinitialCatalogCorrelationsState,
  TCatalogCorrelationDataSource,
} from 'interfaces/catalogCorrelations.interface';
import * as CatalogCorrelationsType from './catalogCorrelations.types';
import { IGenericType } from 'interfaces/generics.interface';

export type TcatalogCorrelationsDispatchReducer =
  | {
      type: typeof CatalogCorrelationsType.SET_CORRELATIONS;
      payload: {
        type: IGenericType;
        data: Array<TCatalogCorrelationDataSource>;
      };
    }
  | {
      type: typeof CatalogCorrelationsType.SET_IS_LOADING;
      payload: boolean;
    }
  | {
      type: typeof CatalogCorrelationsType.SET_IS_LOADING_ASSIGN_GENERICS;
      payload: boolean;
    };

export default function catalogCorrelationsReducer(
  state: IinitialCatalogCorrelationsState,
  action: TcatalogCorrelationsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case CatalogCorrelationsType.SET_CORRELATIONS:
      const setCorrelations: IinitialCatalogCorrelationsState = {
        ...state,
        correlations: {
          ...state.correlations,
          [payload.type]: payload.data,
        },
      };
      return setCorrelations;

    case CatalogCorrelationsType.SET_IS_LOADING:
      const setIsLoading: IinitialCatalogCorrelationsState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;

    case CatalogCorrelationsType.SET_IS_LOADING_ASSIGN_GENERICS:
      const setIsLoadingAssignGenerics: IinitialCatalogCorrelationsState = {
        ...state,
        isLoadingAssignGenerics: payload,
      };
      return setIsLoadingAssignGenerics;

    default:
      return state;
  }
}
